export default class Palette {
    static MAROON = "#a20c14"

    static PESTA_BONEKA_BLUE = "#061a6c"
    static PESTA_BONEKA_LINEN = "#f6efe7"
    static PESTA_BONEKA_PINK = "#f15f91"

}
